// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `form {
  padding-bottom: 4rem;
}

.form-group-button {
  margin: 0 0 20px 0;
}

a.green-text {
  font-size: 15px;
  font-family: "PFBeauSansPro", sans-serif;
  text-align: left;
  margin: 0 0 25px 0;
  cursor: pointer;
  font-weight: bold;
  color: #2B8F14;
}
a.green-text .arrow-green {
  background-image: url("https://static-qa.fif.tech/onboarding-peru-cuentas-assets/accounts/assets/icons/generic/arrow-up-right-green.svg");
  background-repeat: no-repeat;
  display: inline-block;
  height: 20px;
  width: 15px;
  margin-top: 0px;
}

#termsAndConditionsContractLabel {
  margin: 20px 0;
}

#notClientConfig2ContractLabel,
#notClientConfig2ContractCheck {
  margin-bottom: 35px;
}

.wc-container .wc-container-in .sub-title-gray, .wc-container .wc-container-in .email-card-wrapper,
.wc-container .wc-container-in #notClientConfig2TermsLabel, .wc-container .wc-container-in #termsAndConditionsContractLabel {
  text-align: left;
}
.wc-container .wc-container-in .email-card-wrapper__icon {
  margin-right: 5px;
  float: left;
}
.wc-container .wc-container-in .form-group-button {
  margin: 60px 0 10px 0;
}
.wc-container .wc-container-in .form-group-button .btn-secondary:disabled {
  color: #fff;
}

.custom-checkbox {
  margin: 0 0 2em 1.2em;
  text-align: left;
}
.custom-checkbox input[type=checkbox] + label:before {
  padding-left: 8;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
